export default {
	namespaced: true,
	state: () => ({
		withdrawalNum: 0, // 提现人数
		withdrawalCount: 0, // 提现金额
		list: [], // 晒单列表
		lastId: 0, // 分页起始数据 id
		rewardCoin: 0, // 晒单奖励金币
		canShow: true, // 是否可以发起晒单

		shareEditPage: {
			showTextList: [],
			earnWay: {},
			rewardCoin: 0, // 晒单奖励金币
		},
	}),
	mutations: {
		updateList(state, data) {
			state.list = [...state.list, ...data];
		},
		setLastId(state, data) {
			state.lastId = data;
		},
		setRewardCoin(state, data) {
			state.rewardCoin = data;
		},
		setCanShow(state, data) {
			state.canShow = data;
			console.log('canShow', state.canShow);
		},
		setShareEditData(state, data) {
			state.shareEditPage = Object.assign(state.shareEditPage, data);
		},
		setWithdrawInfo(state, data) {
			state.withdrawalNum = data.withdrawalNum;
			state.withdrawalCount = data.withdrawalCount;
		},
		initList(state, data) {
			state.list = [...data];
		},
	},
	actions: {
		initShareOrderData({ commit }, data) {
			const {
				withdrawal_num: withdrawalNum,
				withdrawal_count: withdrawalCount,
				show_list: { list, last_id: lastId },
				show_reward: rewardCoin,
				can_show: canShow,
			} = data;
			commit('initList', list || []);
			commit('setLastId', lastId);
			commit('setRewardCoin', rewardCoin || []);
			commit('setCanShow', canShow);
			commit('setWithdrawInfo', { withdrawalNum, withdrawalCount });
		},
		updateShareOrderData({ commit }, data) {
			const {
				withdrawal_num: withdrawalNum,
				withdrawal_count: withdrawalCount,
				show_list: { list, last_id: lastId },
				show_reward: rewardCoin,
				can_show: canShow,
			} = data;
			commit('updateList', list || []);
			commit('setLastId', lastId);
			commit('setRewardCoin', rewardCoin || []);
			commit('setCanShow', canShow);
			commit('setWithdrawInfo', { withdrawalNum, withdrawalCount });
		},
		initShareEditData({ commit }, data) {
			const { show_reward: rewardCoin, earn_way_mapping: earnWay, show_text_list: showTextList } = data;

			commit('setShareEditData', { showTextList, earnWay, rewardCoin });
		},
	},
	getters: {
		list: (state) => {
			return state.list;
		},
		lastId: (state) => {
			return state.lastId;
		},
		rewardCoin: (state) => {
			return state.rewardCoin;
		},
		canShow: (state) => {
			return state.canShow;
		},
		withdrawalNum: (state) => {
			return state.withdrawalNum;
		},
		withdrawalCount: (state) => {
			return state.withdrawalCount;
		},
		shareEditPage: (state) => {
			return state.shareEditPage;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Withdraw/modules/share-order.js